import { FC, useContext } from 'react';

import { Typography, Link } from '@/shared/ui';

import AuthContext from '@/contexts/Auth/AuthContext';

import './TattooRecognitionInfo.scss';

export const TattooRecognitionInfo: FC = () => {
  const { storedLinks } = useContext(AuthContext);
  const { phone = '', email = '', schedule = '', email_instruction = '' } = storedLinks?.rmpc ?? {};

  return (
    <div className="tattoo-details__modal-recognition">
      <div className="tattoo-details__modal-recognition-content">
        <Typography variant="H2">Впізнали татуювання? Подзвоніть нам на короткий номер {phone}</Typography>
        <Typography variant="H4">{schedule}</Typography>
      </div>
      <div className="tattoo-details__modal-recognition-content">
        <Typography variant="H2">
          Або напишіть на{` `}
          <Link to={`mailto:${email}`}>
            <Typography variant="H2" as="span">
              {email}
            </Typography>
          </Link>
        </Typography>
        <Typography variant="H4">{email_instruction}</Typography>
      </div>
    </div>
  );
};
